export default "__VITE_ASSET__V2LfMw2W__"